import shortid from 'shortid';
import BEM_FIELDS from '../consts/bem-fields';
import COMBO_FIELDS from '../consts/combo-fields';
import DADOS_SIM from '../consts/consts';
import { LISTA_BENS_FIELDS } from '../consts/dados-complementares-fields';
import ENUM from '../consts/enum';
import MOTOR_FIELDS from '../consts/motor';
import { RECTANGLE_STATUS_COLOR } from '../consts/rectangle-color';
import { FROM_HISTORICO_KEY, MSG_HISTORICO_KEY } from '../consts/system-const';
import { moneyPattern, appendZerosLeft } from '../normalizers/normalize';
import SessionService from './session-service';

const listaBemValues = DADOS_SIM.LISTA_BENS;
const dadosCotacaoValues = DADOS_SIM.DADOS_COTACAO;
const dadosClienteValues = DADOS_SIM.DADOS_CLIENTE;
const questionarioValues = DADOS_SIM.QUESTIONARIO_RESPOSTAS;
const enderecoValues = DADOS_SIM.ENDERECO;
const enderecoFields = LISTA_BENS_FIELDS.ENDERECO;
const beneficiarioValues = DADOS_SIM.BENEFICIARIOS;
const beneficiarioFields = LISTA_BENS_FIELDS.BENEFICIARIOS;
const dadosBancariosFields = LISTA_BENS_FIELDS.DADOS_BANCARIOS;
const pagamentoValues = DADOS_SIM.PAGAMENTO;
const detalhesEquipamentoValues = DADOS_SIM.DETALHES_EQUIPAMENTOS;
const detalhesEquipamentoFields = LISTA_BENS_FIELDS.DETALHE_EQUIPAMENTO;
const informacaoAdicionalFields = LISTA_BENS_FIELDS.INFORMACAO_ADICIONAL;
const geolocalizacaoValues = DADOS_SIM.GEOLOCALIZACAO;
const geoLocalizacaoFields = LISTA_BENS_FIELDS.GEOLOCALIZACAO;
const coCorretagemValues = DADOS_SIM.COCORRETAGEM;
const coCorretagemFields = LISTA_BENS_FIELDS.COCORRETAGEM;
const comboSelecionadoFields = COMBO_FIELDS.SELECIONADO;
const conteudoValues = DADOS_SIM.CONTEUDO;
const bemFields = BEM_FIELDS;
const motorFields = MOTOR_FIELDS;

export function treatementDataFromApiAndSetToSession(data) {
    const { cotacao, bens, bensRemovidos, resultadoCalculo, mensagem } = data;

    const listaEnderecos = getListaEnderecos(bens);
    const listaBeneficiarios = getListaBeneficiarios(bens);

    const { resultadoCalculoRetorno, comboSelecionado } = getResultadoCalculoAndComboSelecionado(
        cotacao,
        resultadoCalculo
    );
    const listaBensFiltrados = tratarListaBensRetorno(data, listaEnderecos, listaBeneficiarios, true);
    const listaBensCompleto =
        bensRemovidos &&
        listaBensFiltrados.concat(
            tratarListaBensRetorno(
                { [listaBemValues.LISTA_BENS]: bensRemovidos },
                listaEnderecos,
                listaBeneficiarios,
                true
            )
        );

    const listaBensGarantia = listaBensCompleto.filter((bem) => bem[listaBemValues.GARANTIA]);
    const listaBensNaoGarantia = listaBensCompleto.filter((bem) => !bem[listaBemValues.GARANTIA]);

    const dadosCliente = getDadosClienteFromObj(cotacao);

    let dadosContato, dadosFormaPagamento, dadosCoCorretagem;
    if (cotacao[dadosCotacaoValues.STATUS_COTACAO] === ENUM.STATUS_COTACAO.PROPOSTA_FINALIZADA) {
        dadosContato = getInformacoesAdicionais(cotacao);
        dadosFormaPagamento = getDadosFormaPagamento(cotacao);
        dadosCoCorretagem = getDadosCoCorretagem(cotacao);
    }

    const sessionObj = {
        ...dadosCliente,
        dadosContato: dadosContato,
        [coCorretagemValues.THIS]: dadosCoCorretagem,
        [pagamentoValues.THIS]: dadosFormaPagamento,
        [enderecoValues.THIS]: listaEnderecos,
        [beneficiarioValues.THIS]: listaBeneficiarios,
        [comboSelecionadoFields.THIS]: comboSelecionado,
        [motorFields.RESULTADO_CALCULO]: resultadoCalculoRetorno,
        [listaBemValues.THIS]: listaBensCompleto,
        listaBensFiltrados: listaBensFiltrados,
        listaBensGarantia,
        listaBensNaoGarantia,
        [FROM_HISTORICO_KEY]: true,
        [MSG_HISTORICO_KEY]: mensagem
    };

    /** Seta a Sessão com os dados do Historico */
    SessionService.clearSession();
    SessionService.setSession(removePoligonoAndKmlFromSessaoObj(sessionObj));
    SessionService.setSessionId(sessionObj[dadosCotacaoValues.CODIGO_COTACAO]);
    /**  */

    return sessionObj;
}

export function tratarListaBensRetorno(objRetorno, listaEnderecos, listaBeneficiarios, doNotGetQuestionario) {
    return objRetorno[listaBemValues.LISTA_BENS].map((bem) => {
        const detalhesEquipamento = bem[detalhesEquipamentoFields.THIS];

        let nextBem = {
            ...bem,
            iconNameCollapse: 'angle double down',
            [listaBemValues.ID]: bem[listaBemValues.ID] ? bem[listaBemValues.ID] : shortid.generate(),
            isCollapse: true,
            statusRectangleColor: RECTANGLE_STATUS_COLOR.LARANJA,
            [listaBemValues.VALOR_UNITARIO_BEM]: moneyPattern(
                parseFloat(bem[listaBemValues.VALOR_UNITARIO_BEM]).toFixed(2)
            ),
            [listaBemValues.ID_TIPO_BEM]: bem[listaBemValues.TIPO_BEM][listaBemValues.ID_TIPO_BEM],
            [listaBemValues.ID_TIPO_CONSTRUCAO]: bem[listaBemValues.TEXTO_TIPO_CONSTRUCAO]
                ? bem[listaBemValues.TEXTO_TIPO_CONSTRUCAO][listaBemValues.ID_TIPO_CONSTRUCAO]
                : null,
            [listaBemValues.TIPO_BEM]: bem[listaBemValues.TIPO_BEM][listaBemValues.TIPO_BEM],
            [listaBemValues.TEXTO_TIPO_CONSTRUCAO]: bem[listaBemValues.TEXTO_TIPO_CONSTRUCAO]
                ? bem[listaBemValues.TEXTO_TIPO_CONSTRUCAO][listaBemValues.TEXTO_TIPO_CONSTRUCAO]
                : null,
            [listaBemValues.CAMPOS_PREENCHIDOS]: false,
            [beneficiarioValues.THIS]: [],
            [listaBemValues.RETANGULO_DADOS_COMPLEMENTARES]: {
                position: 'absolute',
                left: 0,
                width: 10,
                height: 56,
                alignItems: 'flex-start',
                backgroundColor: RECTANGLE_STATUS_COLOR.LARANJA
            },
            [enderecoValues.ID_ENDERECO]: getEnderecoBem(bem, listaEnderecos),
            [geolocalizacaoValues.DESENHAR_BUTTON]: false,
            [listaBemValues.KML]: null,
            [listaBemValues.COORDENADAS]: bem[geoLocalizacaoFields.THIS],
            [listaBemValues.POLIGONOS]: bem[listaBemValues.POLIGONOS],
            [listaBemValues.QUESTIONARIO_RESPOSTAS]: doNotGetQuestionario ? [] : getQuestionarioRespostaBem(bem),
            [listaBemValues.COTACAO_CONTEUDO]: getConteudoBem(bem),
            [beneficiarioValues.THIS]: getListaBeneficiariosBem(bem, listaBeneficiarios),
            [detalhesEquipamentoValues.CHASSI]:
                detalhesEquipamento && detalhesEquipamento[detalhesEquipamentoFields.CHASSI],
            [detalhesEquipamentoValues.MODELO]:
                detalhesEquipamento && detalhesEquipamento[detalhesEquipamentoFields.MODELO],
            [detalhesEquipamentoValues.FABRICANTE]:
                detalhesEquipamento && detalhesEquipamento[detalhesEquipamentoFields.FABRICANTE]
        };

        delete nextBem.questionarios;

        return nextBem;
    });
}

export function getDadosClienteFromObj(response) {
    let fieldsDadosCliente = {};

    if (response) {
        if (response.cpf || response.cnpj) {
            fieldsDadosCliente[dadosClienteValues.CPF_CNPJ] = response.cpf ? response.cpf : response.cnpj;
        }
        if (response.razaoSocial) {
            fieldsDadosCliente[dadosClienteValues.NOME_EMPRESA] = response.razaoSocial;
        }
        if (response.codigoCotacao) {
            fieldsDadosCliente[dadosClienteValues.CODIGO_COTACAO] = response.codigoCotacao;
        }
        if (response.email) {
            fieldsDadosCliente[dadosClienteValues.EMAIL] = response.email;
        }
        if (response.agencia.agenciaId) {
            fieldsDadosCliente[dadosClienteValues.NUMERO_AGENCIA] = appendZerosLeft(response.agencia.agenciaId);
        }
        if (response.telefone) {
            fieldsDadosCliente[dadosClienteValues.TELEFONE] = response.telefone;
        }
        if (response.agencia[dadosClienteValues.NOME_AGENCIA]) {
            fieldsDadosCliente[dadosClienteValues.NOME_AGENCIA] = response.agencia[dadosClienteValues.NOME_AGENCIA];
        }
        if (response.tipoCotacao[dadosCotacaoValues.ID_TIPO_COTACAO]) {
            fieldsDadosCliente[dadosCotacaoValues.ID_TIPO_COTACAO] =
                response.tipoCotacao[dadosCotacaoValues.ID_TIPO_COTACAO];
        }
        if (response[dadosCotacaoValues.NUMERO_PRODUTO]) {
            fieldsDadosCliente[dadosCotacaoValues.NUMERO_PRODUTO] = response[dadosCotacaoValues.NUMERO_PRODUTO];
        }
        if (
            response[dadosCotacaoValues.CODIGO_ACESSO] &&
            response[dadosCotacaoValues.CODIGO_ACESSO][dadosCotacaoValues.CODIGO_ACESSO]
        ) {
            fieldsDadosCliente[dadosCotacaoValues.CODIGO_ACESSO] =
                response[dadosCotacaoValues.CODIGO_ACESSO][dadosCotacaoValues.CODIGO_ACESSO];
        }
        if (response[dadosCotacaoValues.STATUS_COTACAO]) {
            fieldsDadosCliente[dadosCotacaoValues.STATUS_COTACAO] = response[dadosCotacaoValues.STATUS_COTACAO];
        }
        if (response[dadosCotacaoValues.CRIADO_EM]) {
            fieldsDadosCliente[dadosCotacaoValues.CRIADO_EM] = response[dadosCotacaoValues.CRIADO_EM];
        }
        if (response[dadosCotacaoValues.VENCIMENTO_SIMULACAO]) {
            fieldsDadosCliente[dadosCotacaoValues.VENCIMENTO_SIMULACAO] =
                response[dadosCotacaoValues.VENCIMENTO_SIMULACAO];
        }
    }
    return fieldsDadosCliente;
}

function getListaEnderecos(listaBens) {
    if (listaBens && listaBens.length > 0) {
        const listaEnderecos = [];

        listaBens.forEach((bem) => {
            const enderecoBem = bem[enderecoFields.THIS];

            const alreadyExists = listaEnderecos.find(
                (end) => end[enderecoValues.CEP] === enderecoBem[enderecoFields.CEP]
            );

            if (enderecoBem && !alreadyExists) {
                listaEnderecos.push({
                    id: shortid.generate(),
                    [enderecoValues.BAIRRO_DISTRITO]: enderecoBem[enderecoFields.BAIRRO],
                    [enderecoValues.CEP]: enderecoBem[enderecoFields.CEP],
                    [enderecoValues.CIDADE]: enderecoBem[enderecoFields.CIDADE],
                    [enderecoValues.COMPLEMENTO]: enderecoBem[enderecoFields.COMPLEMENTO],
                    [enderecoValues.RUA_ESTRADA]: enderecoBem[enderecoFields.LOGRADOURO],
                    [enderecoValues.NOME_PROPRIEDADE]: enderecoBem[enderecoFields.NOME_PROPRIEDADE],
                    [enderecoValues.NUMERO_PROPRIEDADE]: enderecoBem[enderecoFields.NUMERO],
                    [enderecoValues.UF]: enderecoBem[enderecoFields.UF]
                });
            }
        });

        return listaEnderecos;
    } else {
        return [];
    }
}

function getListaBeneficiarios(listaBens) {
    if (listaBens && listaBens.length > 0) {
        const listaBeneficiarios = [];

        listaBens.forEach((bem) => {
            const listaBeneficiariosBem = bem[beneficiarioFields.THIS];

            if (listaBeneficiariosBem && listaBeneficiariosBem.length > 0) {
                listaBeneficiariosBem.forEach((beneficiarioBem) => {
                    const alreadyExists = listaBeneficiarios.find((benef) => {
                        const cpfBenef = beneficiarioBem[beneficiarioFields.CPF];
                        const cnpjBenef = beneficiarioBem[beneficiarioFields.CNPJ];

                        const cpfCnpj = cpfBenef ? cpfBenef : cnpjBenef;

                        return benef[beneficiarioValues.CPF_CNPJ_BENEFICIARIO] === cpfCnpj;
                    });

                    if (beneficiarioBem && !alreadyExists) {
                        const dadosBancarios = beneficiarioBem[dadosBancariosFields.THIS];
                        const banco = dadosBancarios && dadosBancarios[dadosBancariosFields.BANCO];
                        const cpf = beneficiarioBem[beneficiarioFields.CPF];
                        const cnpj = beneficiarioBem[beneficiarioFields.CNPJ];

                        listaBeneficiarios.push({
                            [beneficiarioValues.ID_BENEFICIARIO]: shortid.generate(),
                            [beneficiarioValues.CPF_CNPJ_BENEFICIARIO]: cpf ? cpf : cnpj,
                            [beneficiarioValues.APELIDO]: beneficiarioBem[beneficiarioFields.NOME_ABREVIADO],
                            [beneficiarioValues.NOME_BENEFICIARIO]: beneficiarioBem[beneficiarioFields.NOME_COMPLETO],
                            [beneficiarioValues.VALOR_LMI]: beneficiarioBem[beneficiarioFields.PERCENTUAL_PARTICIPACAO],
                            [pagamentoValues.ID_BANCO]: banco && banco[dadosBancariosFields.BANCO_ID],
                            [pagamentoValues.ID_BANCO_REDIS]: banco && banco[pagamentoValues.ID_BANCO_REDIS],
                            [pagamentoValues.NOME_BANCO]: banco && banco[dadosBancariosFields.NOME_BANCO],
                            [pagamentoValues.DIGITO_AGENCIA]:
                                dadosBancarios && dadosBancarios[dadosBancariosFields.DIGITO_AGENCIA],
                            [pagamentoValues.DIGITO_CONTA]:
                                dadosBancarios && dadosBancarios[dadosBancariosFields.DIGITO_CONTA],
                            [pagamentoValues.NUMERO_AGENCIA]:
                                dadosBancarios && dadosBancarios[dadosBancariosFields.NUMERO_AGENCIA],
                            [pagamentoValues.NUMERO_CONTA]:
                                dadosBancarios && dadosBancarios[dadosBancariosFields.NUMERO_CONTA],
                            [pagamentoValues.FORMA_PAGAMENTO]:
                                dadosBancarios && dadosBancarios[dadosBancariosFields.TIPO_CONTA]
                        });
                    }
                });
            }
        });

        return listaBeneficiarios;
    } else {
        return [];
    }
}

function getInformacoesAdicionais(values) {
    const infoAdicional = values[informacaoAdicionalFields.THIS];

    return {
        [dadosClienteValues.EMAIL_ADICIONAL]: infoAdicional && infoAdicional[informacaoAdicionalFields.EMAIL_ADICIONAL],
        [dadosClienteValues.TELEFONE_ADICIONAL]:
            infoAdicional && infoAdicional[informacaoAdicionalFields.TELEFONE_ADICIONAL],
        [dadosClienteValues.EMAIL_SOLICITANTE]:
            infoAdicional && infoAdicional[informacaoAdicionalFields.EMAIL_SOLICITANTE]
    };
}

function getDadosFormaPagamento(values) {
    const dadosFormaPagamento = values[dadosBancariosFields.FORMA_PAGAMENTO];

    return {
        [pagamentoValues.FORMA_PAGAMENTO]:
            dadosFormaPagamento && dadosFormaPagamento[dadosBancariosFields.FORMA_PAGAMENTO],
        [pagamentoValues.DIA_VENCIMENTO]:
            dadosFormaPagamento && dadosFormaPagamento[dadosBancariosFields.DIA_VENCIMENTO],
        [pagamentoValues.NUMERO_AGENCIA]:
            dadosFormaPagamento && dadosFormaPagamento[dadosBancariosFields.NUMERO_AGENCIA],
        [pagamentoValues.DIGITO_AGENCIA]:
            dadosFormaPagamento && dadosFormaPagamento[dadosBancariosFields.DIGITO_AGENCIA],
        [pagamentoValues.CONTA_BB]: dadosFormaPagamento && dadosFormaPagamento[pagamentoValues.NUMERO_CONTA],
        [pagamentoValues.DIGITO_CONTA]: dadosFormaPagamento && dadosFormaPagamento[dadosBancariosFields.DIGITO_CONTA]
    };
}

function getDadosCoCorretagem(values) {
    const dadosCoCorretagem = values[coCorretagemFields.THIS];

    let newDadosCoCorretagem = {};
    dadosCoCorretagem &&
        dadosCoCorretagem.forEach((corretor, index) => {
            newDadosCoCorretagem = {
                ...newDadosCoCorretagem,
                [coCorretagemValues.CNPJ_CORRETORA(index)]: corretor[coCorretagemFields.CNPJ],
                [coCorretagemValues.NOME_CORRETORA(index)]: corretor[coCorretagemFields.NOME_CORRETORA]
            };
        });

    return newDadosCoCorretagem;
}

function getEnderecoBem(bem, listaEnderecos) {
    if (bem && listaEnderecos && listaEnderecos.length > 0) {
        const enderecoBem = bem[enderecoFields.THIS];

        const enderecoToReturn = listaEnderecos.find(
            (end) => end[enderecoValues.CEP] === enderecoBem[enderecoFields.CEP]
        );
        return enderecoToReturn && enderecoToReturn.id;
    } else {
        return null;
    }
}

function getListaBeneficiariosBem(bem, listaBeneficiarios) {
    if (bem && listaBeneficiarios && listaBeneficiarios.length > 0) {
        const listaBeneficiariosBem = bem[beneficiarioFields.THIS];
        const newListaBeneficiariosBem = [];

        listaBeneficiariosBem &&
            listaBeneficiariosBem.forEach((benef) => {
                const beneficiarioToAdd = listaBeneficiarios.find((benefLista) => {
                    const cpf = benef[beneficiarioFields.CPF];
                    const cnpj = benef[beneficiarioFields.CNPJ];
                    const cpfCnpj = cpf ? cpf : cnpj;

                    return benefLista[beneficiarioValues.CPF_CNPJ_BENEFICIARIO] === cpfCnpj;
                });

                if (beneficiarioToAdd) {
                    newListaBeneficiariosBem.push(beneficiarioToAdd);
                }
            });

        return newListaBeneficiariosBem;
    } else {
        return [];
    }
}

function getQuestionarioRespostaBem(bem) {
    const questionariosBem = bem[bemFields.QUESTIONARIOS];

    if (questionariosBem) {
        const newquestionarioBem = questionariosBem.map((pergunta) => {
            let nextPergunta = {
                ...pergunta,
                [questionarioValues.ID_REDIS]: pergunta.id,
                [questionarioValues.PERGUNTA]: pergunta.descricao
            };
            delete nextPergunta.id;
            delete nextPergunta.descricao;

            return nextPergunta;
        });

        return newquestionarioBem;
    } else {
        return [];
    }
}

function getResultadoCalculoAndComboSelecionado(cotacao, resultadoCalculoRedis) {
    const statusCotacao = cotacao[dadosCotacaoValues.STATUS_COTACAO];

    if (statusCotacao === ENUM.STATUS_COTACAO.SIMULACAO_INICIADA) {
        return { resultadoCalculoRetorno: resultadoCalculoRedis, comboSelecionado: null };
    } else {
        const resultadoCalculoRetorno = cotacao[motorFields.RESULTADO_CALCULO];

        const listaCombos = resultadoCalculoRetorno && resultadoCalculoRetorno[motorFields.SAIDA.LISTA_COMBOS];

        return {
            resultadoCalculoRetorno,
            comboSelecionado: listaCombos && listaCombos[0]
        };
    }
}

function getConteudoBem(bem) {
    const listaConteudoBem = bem[bemFields.CONTEUDOS];
    return listaConteudoBem
        .map((conteudo) =>
            conteudo[conteudoValues.ID_CONTEUDO]
                ? {
                      ...conteudo,
                      [conteudoValues.VALOR_UNITARIO_CONTEUDO]: parseFloat(
                          conteudo[conteudoValues.VALOR_UNITARIO_CONTEUDO]
                      ).toFixed(2),
                      id: shortid.generate()
                  }
                : null
        )
        .filter((el) => el);
}

function removePoligonoAndKmlFromSessaoObj(sessaoObj) {
    return {
        ...sessaoObj,
        [listaBemValues.THIS]: removePoligonoAndKmlFromListBens(sessaoObj[listaBemValues.THIS]),
        listaBensFiltrados: removePoligonoAndKmlFromListBens(sessaoObj.listaBensFiltrados),
        listaBensGarantia: removePoligonoAndKmlFromListBens(sessaoObj.listaBensGarantia),
        listaBensNaoGarantia: removePoligonoAndKmlFromListBens(sessaoObj.listaBensNaoGarantia)
    };
}

function removePoligonoAndKmlFromListBens(listaBens) {
    return (
        listaBens &&
        listaBens.map((e) => ({
            ...e,
            [listaBemValues.KML]: null,
            [listaBemValues.POLIGONOS]: []
        }))
    );
}
